export default {
  new_chat_shortcut_helper: 'Chat nuevo',
  keyboard_shortcuts: 'Atajos del teclado',
  search_conversations: 'Buscar conversaciones',
  close_current_chat_tab: 'Cerrar la pesta\u00f1a del chat actual',
  move_focus_to_editor: 'Mover el enfoque al editor de mensajes',
  cycle_through_chats_down:
    'Hacer un ciclo por las pesta\u00f1as de los chats abiertos (hacia abajo)',
  open_recent_contacts: 'Chats recientes y directorio',
  toggle_sidebar: 'Alternar la barra lateral derecha',
  reopen_last_tab: 'Reabrir la \u00faltima pesta\u00f1a de chat cerrada',
  cycle_through_chats_up:
    'Hacer un ciclo por las pesta\u00f1as de los chats abiertos (hacia arriba)',
  show_this_list: 'Mostrar esta lista',
};
